import { createAction } from '@reduxjs/toolkit'

import { KpiVariableOption } from 'types/GlobalCompanyGroups'

// tryGetAllKpiVariableOptions
export const getAll = createAction('get_all_kpi_variable_options')
export const getAllSuccess = createAction<KpiVariableOption[]>(
  'get_all_kpi_variable_options_success'
)
export const getAllFailed = createAction('get_all_kpi_variable_options_failed')

// tryPutKpiVariableOptions
export const update = createAction('update_kpi_variable_options')
export const updateSuccess = createAction<KpiVariableOption[]>(
  'update_kpi_variable_options_success'
)
export const updateFailed = createAction('update_kpi_variable_options_failed')
